import {createContext, useContext, useReducer, useState} from "react";

import { ACTION_TYPE, reducers } from "./reducer";
import { useMutation, useQuery } from "react-query";
import { GET_NOTIFICATIONS } from "services/notifications";
import { MARK_READ } from "services/notifications";

const NotificationStateContext = createContext()
const NotificationDispatchContext = createContext()

const defaultState = {
    notifications: []
}

const NotificationProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducers, defaultState);

    return (
        <NotificationStateContext.Provider value={{ ...state }}>
            <NotificationDispatchContext.Provider value={dispatch}>
                {children}
            </NotificationDispatchContext.Provider>
        </NotificationStateContext.Provider>
    );
}

const useNotifications = () => {
    const context = useContext(NotificationStateContext)

    if (!context)
        throw new Error("Notification Provider")

    return context
}

const useNotificationsDispatch = () => {
    const dispatch = useContext(NotificationDispatchContext)

    if (!dispatch)
        throw new Error("Notification Provider")

    return dispatch
}

const useGetLastNotifications = () => {
    const dispatch = useContext(NotificationDispatchContext)

    return useQuery(["notifications"], () => GET_NOTIFICATIONS(), {
        onSuccess: (data) => {
            dispatch({type: ACTION_TYPE.LOAD_LAST_NOTIFICATIONS, data})
        },
    })
}

const useReadNotification = () => {
    return useMutation((data) => MARK_READ(data))
}

export {
    NotificationProvider,
    useNotifications,
    useNotificationsDispatch,
    useGetLastNotifications,
    useReadNotification
}